import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import { ExpandableSection } from '../../components/expandableSection';
import { GameGuideHelpButton } from '../../components/gameGuideHelpButton';
import { IconWithLabelDisplay } from '../../components/iconWithLabelDisplay';
import { PowerPlayerFeatureIndicator } from '../../components/messageBoxes/settingsModal/powerPlayerFeatureIndicator';
import { useAppSelector } from '../../redux/store';
import { LIGHT_BLUE_COLOR, PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR, YELLOW_COLOR } from '../../styles/colors';
import { PanelItemDivider } from '../panelItemDivider';
import { PlayerStyleMeterDisplay } from './playerStyleMeterDisplay';
const MIN_NUM_HANDS = 25;
const STYLE_CONTAINER_CSS = css `
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
const NICKNAME_CONTAINER_CSS = css `
  align-self: center;
`;
const STYLE_ROW_CSS = css `
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`;
export const PlayerStylePanelItem = ({ username, playerStyle }) => {
    const isSelfPowerPlayer = useAppSelector((state) => state.selfData.isPowerPlayer);
    const { numHands, vpipScore, vpipLabel, afScore, afLabel, styleNickname } = playerStyle;
    function getContents() {
        if (!isSelfPowerPlayer) {
            return _jsx(PowerPlayerFeatureIndicator, { powerPlayerBoltColor: 'black', isClickable: true });
        }
        if (numHands < MIN_NUM_HANDS) {
            return (_jsx(IconWithLabelDisplay, { icon: _jsx(ScheduleRoundedIcon, {}), label: `Waiting for ${username || 'you'} to play more hands...`, isSubtle: true }));
        }
        return (_jsxs("div", { css: STYLE_CONTAINER_CSS, children: [_jsxs("div", { css: NICKNAME_CONTAINER_CSS, children: ["\"", styleNickname, "\""] }), _jsx(PanelItemDivider, { color: PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR, thicknessPx: 2 }), _jsxs("div", { css: STYLE_ROW_CSS, children: [_jsx("span", { children: "Aggression:" }), _jsxs("div", { children: [_jsx(PlayerStyleMeterDisplay, { score: afScore, color: YELLOW_COLOR, label: 'Aggression' }), _jsx("div", { children: afLabel })] })] }), _jsx(PanelItemDivider, { color: PLAYER_INFO_PANEL_CONTENT_HOVER_COLOR, thicknessPx: 2 }), _jsxs("div", { css: STYLE_ROW_CSS, children: [_jsx("span", { children: "Hand Selection:" }), _jsxs("div", { children: [_jsx(PlayerStyleMeterDisplay, { score: vpipScore, color: LIGHT_BLUE_COLOR, label: 'Hand Selection' }), _jsx("div", { children: vpipLabel })] })] })] }));
    }
    return (_jsx(ExpandableSection, { expandableSectionType: username ? 'player-style' : 'self-style', colorType: 'player-info', headerRight: _jsx(GameGuideHelpButton, { pageType: 'play-style', title: 'Play Style Info' }), children: getContents() }));
};
